import Bugsnag from "@bugsnag/js";
import axios from "axios";
import React, { Component } from "react";
import Marquee from "react-fast-marquee";
import SEO from "react-seo-component";
import util from "../../util";
import cookie from "react-cookies";
import VehiclesTypes from "../../components/Vehicles/Vehicles";

import {
  Button,
  ButtonGroup,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import PlacesAutocomplete from "../../components/common/PlacesAutocomplete";
import constants from "../../Constants";
import news from "../articles/news";
import reviews from "../articles/reviews";

const baseURL = constants.baseURL;
class Section extends Component {
  constructor() {
    super();

    let promoCode = "";
    try {
      const queryParams = new URLSearchParams(window.location.search);
      promoCode = queryParams.get("promocode") || "";
    } catch (error) {
      Bugsnag.notify(error);
    }
    if (cookie.load("qtcid_")) {
      window.location.href = "/customer-truck-hire";
    }

    this.state = {
      loading: false,
      success: false,
      trackYourOrder: false,
      openSuccessModal: false,
      trucktypes: "motorbike",
      apierror: "",
      collectionlat: 0,
      collectionlng: 0,
      fullname: "",
      frequency: "monthly",
      email: "",
      mobilenumber: "",
      companyname: "",
      collectiondate: "",
      collectiontime: "",
      description: "",
      driverrequired: 1,
      openDiscountCode: false,
      promoCode: promoCode || "",
      vehicletypes: [],
    };
  }

  getVehicleTypes() {
    const { vehicletypes } = this.state;
    if (vehicletypes?.length === 0)
      axios.get(baseURL + "/vehicle-types").then((repos) => {
        const vehicletypesdata = repos.data;
        this.setState({
          vehicletypes: vehicletypesdata?.vehicles,
          vehiclecategories: vehicletypesdata?.categories,
          vehicleconfigurations: vehicletypesdata?.configurations,
        });
      });
  }

  changeTruck() {
    this.setState(
      {
        trucktypes: "",
        truckTonnes: undefined,
        fullQuote: {
          tripDistance: 0,
          tripDuration: 0,
          sellingPrice: 0,
          storedQuoteId: "",
          discount: "",
        },
      },
      () => {
        window.document.getElementById("vehiclelist").scrollIntoView();
      }
    );
  }

  validStepTwo() {
    const {
      trucktypes,
      email,
      mobilenumber,
      companyname,
      fullname,
      collectiondate,
      collectionlat,
      collectionlng,
      description,
      frequency,
    } = this.state;

    return (
      trucktypes.length > 0 &&
      email.length > 0 &&
      mobilenumber.length > 0 &&
      companyname.length > 0 &&
      fullname.length > 0 &&
      collectiondate.length > 0 &&
      collectionlat !== 0 &&
      collectionlng !== 0 &&
      description.length > 0 &&
      frequency.length > 0
    );
  }

  requestQuote() {
    this.setState({
      loading: true,
      apierror: "",
    });
    const {
      trucktypes,
      email,
      mobilenumber,
      companyname,
      fullname,
      collectiondate,
      collectionlat,
      collectionlng,
      description,
      frequency,
      promocode,
      driverrequired,
    } = this.state;

    axios
      .post(baseURL + "/vehicle-hire-quote", {
        trucktypes,
        email,
        mobilenumber,
        companyname,
        fullname,
        collectiondate,
        collectionlat,
        collectionlng,
        description,
        frequency,
        promocode,
        driverrequired,
        source_:
          util.navigator_() + util.source_() + " qtref:" + document?.referrer,
      })
      .then((response) => {
        this.setState({
          loading: false,
          success: response.status === 200,
          openSuccessModal: true,
        });
      })
      .catch((e) => {
        this.setState({
          loading: false,
          apierror: "Request failed. Please try again.",
        });
      });
  }

  getImage(trucktype) {
    try {
      return `https://media.qiktruck.co.za/${trucktype}.png`;
    } catch (error) {
      return "";
    }
  }

  render() {
    this.getVehicleTypes();
    const { vehicletypes, promoCode, frequency } = this.state;
    return (
      <React.Fragment>
        <div id={"pagefragmenttop"}></div>
        <SEO
          title={this.props.title || "Book a demo today"}
          titleTemplate={this.props.titleTemplate || "QikTruck"}
          titleSeparator={this.props.titleSeparator || `-`}
          description={
            this.props.pageDescription ||
            "Hire a delivery vehicle for your business and save on your transportation costs."
          }
          image={
            this.props.image ||
            "https://media.qiktruck.co.za/qiktruck-preview-header.png"
          }
          pathname={
            this.props.pathname || "https://qiktruck.co.za/regular-deliveries"
          }
          twitterUsername={"qiktrucksa"}
        />
        <section className="hero-section" id={"pagetop"}>
          <Modal isOpen={this.state.success && this.state.openSuccessModal}>
            <ModalHeader>
              <i className={"mdi mdi-check-circle  order-received"}></i>
              Request Received
            </ModalHeader>
            <ModalBody>
              <ListGroup className="black-text">
                <ListGroupItem>
                  <i className={"mdi mdi-check-circle order-received-list"}></i>
                  Our team will be in touch shortly to confirm your order.
                </ListGroupItem>
                <ListGroupItem>
                  <i className={"mdi mdi-check-circle order-received-list"}></i>
                  Happy moving!
                </ListGroupItem>
              </ListGroup>
            </ModalBody>
            <ModalFooter>
              <Button
                color="primary"
                onClick={() =>
                  (window.location.href = "/truck-hire-thanks?real=true")
                }
              >
                Okay
              </Button>
            </ModalFooter>
          </Modal>
          <Modal isOpen={this.state.openDiscountCode}>
            <ModalHeader>
              <i className={"mdi mdi-clipboard-text order-received"}></i>
              More options
            </ModalHeader>
            <ModalBody>
              <Label>Discount code</Label>
              <br />
              <span>Lucky one! Our Discount codes are up to 30% off!</span>
              <Input
                id="promocode"
                name="promocode"
                type="promocode"
                defaultValue={promoCode}
                placeholder="Type your discount code here |"
                onChange={(e) => {
                  this.setState({ promoCode: e.target.value.toUpperCase() });
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                onClick={() => {
                  this.setState({
                    openDiscountCode: false,
                  });
                }}
              >
                Cancel
              </Button>
              <Button
                color="primary"
                onClick={() => {
                  this.setState({
                    openDiscountCode: false,
                  });
                }}
              >
                Apply
              </Button>
            </ModalFooter>
          </Modal>
          <Container>
            <div className="store-front">
              <Row>
                <Col lg={12}>
                  <div className="hero-wrapper mb-4">
                    <h2 className="main-headline">
                      {this.props.pageHeading || "Regular deliveries"}
                    </h2>
                    <h6>{this.props.pageSubHeading || "For your business"}</h6>
                    <p>
                      {this.props.pageDescription ||
                        '"Learn more about our services."'}
                    </p>
                    <VehiclesTypes />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <div className="hero-wrapper mb-4">
                    <div id={"vehiclelist"}></div>
                    <Row>
                      <Col lg={6} md={12} className="truck-hire">
                        <h3 className="font-18">
                          <i className="mdi mdi-truck-fast orange"></i> Book
                          drivers and vehicles
                        </h3>
                        <p>
                          <i className="mdi mdi-star orange"></i>Vehicles come
                          with a driver and app.
                        </p>
                        <p>
                          <i className="mdi mdi-star orange"></i>Vehicle + Order
                          tracking enabled.
                        </p>
                        <p>
                          <i className="mdi mdi-star orange"></i>Free Business Logistics
                          Management Platform.
                        </p>
                        <p>
                          <i className="mdi mdi-star orange"></i>3 other
                          vehicles on standby.
                        </p>
                        <p>
                          <i className="mdi mdi-star orange"></i>Regular
                          maintenance.
                        </p>
                      </Col>
                      <Col lg={6} md={12} className="truck-hire">
                        <p>
                          <i className="mdi mdi-star orange"></i>Insurance of up
                          to R500 000+
                        </p>
                        <p>
                          <i className="mdi mdi-star orange"></i>Plus smaller
                          vehicle add-ons for door to door services.
                        </p>
                        <p>
                          <i className="mdi mdi-star orange"></i>Pay for what
                          you use only.
                        </p>
                        <p>
                          <i className="mdi mdi-star orange"></i>Introducing,
                          Move Now Pay Later!
                        </p>
                        <p>
                          <i className="mdi mdi-star orange"></i>24/7 drivers
                          and vehicles available.
                        </p>
                      </Col>
                      <Col lg={6} md={12} className="truck-hire">
                        <h3 className="font-18">
                          <i className="mdi mdi-truck-fast orange"></i>{" "}
                          Distribution Services
                        </h3>
                        <p>
                          <i className="mdi mdi-star orange"></i>Shop to
                          Customers
                        </p>
                        <p>
                          <i className="mdi mdi-star orange"></i>Warehouse to
                          Warehouse
                        </p>
                        <p>
                          <i className="mdi mdi-star orange"></i>Warehouse to
                          Shop
                        </p>
                        <p>
                          <i className="mdi mdi-star orange"></i>Warehouse to
                          Customers
                        </p>
                
                        <p>
                          <i className="mdi mdi-star orange"></i>Storage to
                          Customers and more!
                        </p>
                      </Col>
                      <Col lg={12} sm={12}>
                        <br />
                        <br />
                        <br />
                      </Col>
                      <Col lg={12} md={12}>
                        <h2
                          className={"category-below "}
                          onClick={() => this.changeTruck()}
                        >
                          <i className="mdi mdi-thumb-up-outline"></i> Select a
                          vehicle type below{" "}
                        </h2>
                      </Col>

                      {vehicletypes
                        ?.filter((v) => v.businesshire === true)
                        ?.map((vehicle) => {
                          const image = this.getImage(vehicle.type);
                          return (
                            <Col
                              key={vehicle.type}
                              lg={4}
                              md={4}
                              sm={4}
                              xs={6}
                              xl={2}
                              className={"grey-border-bottom vehicle-type"}
                              onClick={() =>
                                this.setState(
                                  {
                                    trucktypes: vehicle.type,
                                  },
                                  () => {
                                    window.document
                                      .getElementById("fullname")
                                      .scrollIntoView();
                                  }
                                )
                              }
                            >
                              <div
                                className={
                                  this.state.trucktypes === vehicle.type
                                    ? "selected-truck"
                                    : ""
                                }
                              ></div>
                              <img
                                src={image}
                                alt=""
                                className={
                                  "menu-truck " +
                                  (this.state.trucktypes === vehicle.type
                                    ? "menu-truck-selected"
                                    : "")
                                }
                                height="20"
                              />
                              <i
                                className={
                                  "mdi mdi-check-circle ml-2 " +
                                  (this.state.trucktypes === vehicle.type
                                    ? "checked-truck"
                                    : "hide")
                                }
                              ></i>
                              <p className="menu-truck-tip ">
                                {vehicle.tip.shortform}
                                <br />
                                {vehicle.tonnes} tonnes
                                <br />
                                <br />
                                Closed or open body
                                <br />
                              </p>
                            </Col>
                          );
                        })}
                    </Row>
                    <Row>
                      <Col lg={12} sm={12}>
                        <br />
                        <br />
                        <br />
                      </Col>
                      <Col lg={6} sm={12} id="fullname">
                        <FormGroup>
                          <Label for="fullname">Your Fullname</Label>
                          <Input
                            id="fullname"
                            name="fullname"
                            type="text"
                            onChange={(e) => {
                              this.setState({ fullname: e.target.value });
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={6} sm={12}>
                        <FormGroup>
                          <Label for="email">Email</Label>
                          <Input
                            id="email"
                            name="email"
                            type="email"
                            onChange={(e) => {
                              this.setState({ email: e.target.value });
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={6} sm={12}>
                        <FormGroup>
                          <Label for="mobilenumber">Mobile number</Label>
                          <Input
                            id="mobilenumber"
                            name="mobilenumber"
                            type="tel"
                            onChange={(e) => {
                              this.setState({ mobilenumber: e.target.value });
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={6} sm={12} id="companyname">
                        <FormGroup>
                          <Label for="companyname">Company name</Label>
                          <Input
                            id="companyname"
                            name="companyname"
                            type="text"
                            onChange={(e) => {
                              this.setState({ companyname: e.target.value });
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={6} sm={12}>
                        <FormGroup>
                          <Label for="collectiondate">
                            Start date estimate
                          </Label>
                          <Input
                            id="collectiondate"
                            name="collectiondate"
                            placeholder="Collection date"
                            type="date"
                            onChange={(e) => {
                              this.setState({ collectiondate: e.target.value });
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={6} sm={12}>
                        <FormGroup autoComplete="new-password">
                          <Label for="description"> Your Location </Label>
                          <PlacesAutocomplete
                            type="text"
                            className="form-control"
                            id="collection"
                            placeholder=""
                            required
                            autoComplete="new-password"
                            onPlaceSelected={(place) => {
                              if (!place?.geometry?.location?.lat()) {
                                Bugsnag.notify(
                                  new Error(
                                    "COLLECTION place not found: " +
                                      this.state.trucktypes
                                  )
                                );
                              }
                              this.setState({
                                collectionlat: place?.geometry?.location?.lat(),
                                collectionlng: place?.geometry?.location?.lng(),
                              });
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={12} sm={12}>
                        <FormGroup>
                          <Label for="description">Instructions</Label>
                          <Input
                            id="description"
                            name="text"
                            type="textarea"
                            defaultValue={this.state.description}
                            style={{ minHeight: 120 }}
                            placeholder="Any extra information about this request..."
                            onChange={(e) => {
                              this.setState({ description: e.target.value });
                            }}
                          />
                        </FormGroup>
                      </Col>

                      <Col lg={6} sm={12}>
                        <FormGroup>
                          <ButtonGroup>
                            <Button
                              color="primary"
                              outline
                              onClick={() =>
                                this.setState({ frequency: "onceoff" })
                              }
                              active={frequency === "onceoff"}
                            >
                              Once off
                            </Button>
                            <Button
                              color="primary"
                              outline
                              onClick={() =>
                                this.setState({ frequency: "daily" })
                              }
                              active={frequency === "daily"}
                            >
                              Daily
                            </Button>
                            <Button
                              color="primary"
                              outline
                              onClick={() =>
                                this.setState({ frequency: "weekly" })
                              }
                              active={frequency === "weekly"}
                            >
                              Weekly
                            </Button>
                            <Button
                              color="primary"
                              outline
                              onClick={() =>
                                this.setState({ frequency: "monthly" })
                              }
                              active={frequency === "monthly"}
                            >
                              Monthly
                            </Button>
                          </ButtonGroup>
                          {/* <ButtonGroup>
                            <Button
                              color="primary"
                              outline
                              onClick={() =>
                                this.setState({ driverrequired: 1 })
                              }
                              active={driverrequired === 1}
                            >
                              Add Driver
                            </Button>
                            <Button
                              color="primary"
                              outline
                              onClick={() =>
                                this.setState({ driverrequired: 0 })
                              }
                              active={driverrequired === 0}
                            >
                              No Driver
                            </Button>
                          </ButtonGroup> */}
                        </FormGroup>
                      </Col>
                      <Col lg={6} sm={12}>
                        <FormGroup>
                          <div
                            className="selected-button-truck"
                            onClick={() => {
                              this.changeTruck();
                            }}
                          >
                            <img
                              src={this.getImage(this.state.trucktypes)}
                              alt=""
                            />
                            <br />
                            {this.state.trucktypes
                              ? "Change vehicle >"
                              : "No vehicle selected >"}
                          </div>
                          <br />

                          <div
                            onClick={() =>
                              this.setState({ openDiscountCode: true })
                            }
                            className="moreoptions"
                          >
                            {promoCode?.length > 0
                              ? "- Discount code: " + promoCode
                              : " Discounts"}
                            {" >"}
                            <span></span>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>

                    <div
                      style={{
                        width: "100%",
                        display: "block",
                        float: "left",
                        padding: 0,
                        margin: 0,
                      }}
                    >
                      <Button
                        className="float-right mb-4"
                        color="primary"
                        onClick={() => {
                          this.requestQuote();
                        }}
                        style={{ width: "fit-content", marginTop: "20px" }}
                        disabled={!this.validStepTwo() || this.state.loading}
                      >
                        SUBMIT
                        <i className="mdi mdi-arrow-right-bold ml-2"></i>
                      </Button>
                    </div>

                    {this.state.loading === false &&
                      this.state.apierror.length > 0 && (
                        <p className="error-message">{this.state.apierror}</p>
                      )}
                  </div>
                </Col>
              </Row>
            </div>
            <h3 className="font-18">
              {" "}
              <i className="mdi mdi-emoticon-happy orange"></i> Customer reviews
            </h3>
            <Marquee
              gradient={true}
              gradientWidth={0}
              speed={6}
              direction="right"
            >
              {reviews.map((a, index) => (
                <div key={index}>
                  <div className="home-reviews">
                    <h1>{a.heading}</h1>
                    <div className="date-article-added">
                      <i className="mdi mdi-clock-outline ml-2"></i>
                      {a.date}
                      <i className="mdi mdi-pin ml-2"></i>
                      {a.location}
                      {Array.from({ length: a.category }).map((x, index) => (
                        <i className="mdi mdi-star orange" key={index}></i>
                      ))}
                    </div>
                    <p>{a.copy}</p>
                  </div>
                </div>
              ))}
            </Marquee>
            <br />
            <h3>
              {" "}
              <i className="mdi mdi-earth orange"></i> Where are we located?
            </h3>
            <div className="activity-map">
              <br />
              <img
                alt="qiktruck-activity-map"
                src="https://media.qiktruck.co.za/qiktruck-activity-map.png"
              />{" "}
              <ul className="map-benefits">
                <li>
                  We offer transportation services to all areas in South Africa.
                </li>
                <li>
                  <b>
                    We offer you lower prices because our vehicles already
                    operate in your pickup area.
                  </b>
                </li>
                <li>Each order is tailored to the needs of your load.</li>
                <li>
                  <b>Drivers, Vehicles and Bookings are managed by QikTruck.</b>
                </li>
                <li>
                  Drivers approve quotations and orders on the driver app.
                </li>
                <li>
                  <b>Trucks. Anytime. Quick.</b>
                </li>
              </ul>
            </div>
            <br />
            <h3 className="font-18">
              {" "}
              <i className="mdi mdi-truck-fast orange"></i> In the News
            </h3>
            <Marquee
              gradient={true}
              gradientWidth={0}
              speed={6}
              direction="right"
            >
              {news.map((a, index) => (
                <div key={index}>
                  <a
                    className="home-news"
                    href={"/articles/" + a?.pathname?.toLocaleLowerCase()}
                  >
                    <div
                      className="article-list-image"
                      style={{
                        backgroundImage: `url(https://media.qiktruck.co.za/${a.image})`,
                      }}
                      alt={a.image}
                    />
                    <h1>{a.heading}</h1>
                    <div className="date-article-added">
                      <i className="mdi mdi-clock-outline ml-2"></i>
                      {a.date}
                      <i className="mdi mdi-pin ml-2"></i>
                      {a.category}
                    </div>
                    <p>{a.copy}</p>
                  </a>
                </div>
              ))}
            </Marquee>
            <br />
            <br />
            <p>
              {this.props.pageDescription2 ||
                '"Learn more about our services."'}
            </p>
          </Container>
          <div style={{ display: "none", color: "white", height: 0, width: 0 }}>
            {vehicletypes?.map((v, index) => {
              const image = this.getImage(v.type);
              return (
                <div key={index}>
                  <h2>{v.type}</h2>
                  <img src={image} alt={v.tip.shortform} />
                  <h2>{v.type}</h2>
                  <h2>{v.displaytype}</h2>
                  <h2>{v.tip.shortform}</h2>
                </div>
              );
            })}
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
